import { styled } from 'linaria/react';

export const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
`;

export const IconButtonWrapper = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    display: block;
  }
`;

export const IconLink = styled.a`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    display: block;
  }
`;
